export const isTrackingEnabled = () =>
  process.env.NODE_ENV === 'production' && window.CONFIG.ENVIRONMENT === 'production';
